import axios from "axios";

export const baseURL = "https://realverse.site/";
export const apiURL = "https://realverse.site/api/";

export const axe = axios.create({
    baseURL: apiURL,
});

axe.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers["Authorization"] = "Bearer " + token;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axe.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem("accessToken");

            window.location.href = "/admin/login";
        }
        return Promise.reject(error);
    }
);